
<div class="main-crm-container">
    <div class="compare-container">
        <div class="sepration-container" fxLayout.lt-md="column" fxLayoutGap.lt-md="15px">
            <div class="left-crm-container">
                <h2 class="heading-container" [innerHTML]="item?.title"></h2>
                <img  
                [src]="serverPath1+item.customField24" 
                alt="exam-course" 
                class="comparsion-image"
                [ngStyle.lt-md]="{ 'display': 'block', 'margin': '0 auto','width':'100%' }"
                style="width: 250px; object-fit: contain; margin-top: 2.5rem;">
              
                <!-- <picture class="picture-container"></picture> -->


            </div>
            <div class="right-crm-container">
                <div class="input-container">
                    <div class="inner-flex" fxLayout.lt-md="column">
                        <div class="first-input">
                          <label [ngStyle.lt-md]="{ 'margin-bottom': '1rem'}">Select your product:</label>
                          <div class="custom-dropdown">
                            <div class="selected-option" (click)="toggleDropdown()">
                                <div class="text-container">
                                  <span class="product-name">{{ selectedProduct?.name }}</span>
                                  <span class="product-details">{{ selectedProduct?.details }}</span>
                                </div>
                                <span class="dropdown-icon" [ngClass]="{ 'rotate': isDropdownOpen }">▼</span>  
                              </div>
                              
                            <ul *ngIf="dropdownOpen" class="dropdown-list">
                              <li *ngFor="let product of ComparisonList" (click)="selectProduct(product)">
                                <strong>{{ product.name }}</strong>
                                <br />
                                <span class="subtext">{{ product.details }}</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="second-input" >
                          <label [ngStyle.lt-md]="{ 'margin-bottom': '1rem'}">Number of users</label>
                          <input type="number" [(ngModel)]="numUsers" class="custom-input" />
                        </div>
                      </div>

                </div>
                <div class="comparison-container">
                    <p class="comparison-parah-container" [ngStyle.lt-md]="{ 'margin-bottom': '1rem'}">Total cost of each solution is:</p>
                    <div class="comparison-main-container" fxLayout.lt-md="column" fxLayoutGap.lt-md="15px">
                        <div class="container-one">
                            <p class="price-tag">₹ <b>{{ourCRMTotalPrice }}</b> </p>
                            <div class="company-info">
                              <span class="company-logo" [ngStyle]="{'background-image': 'url(' + serverPath1 + ourCRM.image + ')'}"></span>
                              <span class="company-plan-name">
                                {{ ourCRM.details }}
                              </span>
                            </div>
                            

                        </div>
                        <div class="container-one">
                            <p class="price-tag">₹ <b>{{selectedCRMTotalPrice }}</b> </p>
                            <div class="company-info">
                            <span class="company-logo" [ngStyle]="{'background-image': 'url(' + serverPath1 + selectedProduct.image + ')'}">

                            </span>
                            <span class="company-plan-name">
                                {{selectedProduct.details}}
                            </span>
                            </div>

                        </div>

                    </div>
                  
                    
                </div>
                <p class="result-container-one">
                    <span>
                        With <span class="comp-name">{{ ourCRM.name }},</span>
                    </span>
                    you save <span class="price-amount">
                        ₹{{savings}} 
                    </span>
                    /month , for
                    <b class="percentage-amount">
                        {{savingsPercentage }}%
                    </b>


                </p>
              
 
            </div>

        </div>
        <!-- <p class="toggle-text below-text" (click)="toggleTable()">
            <span *ngIf="!showTable" class="spani show-ele">Show pricing breakup for <span class="user-val">100 users</span></span>
            <span *ngIf="showTable" class="spani show-ele">Hide pricing breakup for <span class="user-val">100 users</span></span>

        </p> -->
        <div [@slideAnimation]="showTable ? 'expanded' : 'collapsed'">
            <ng-container *ngIf="showTable">
              <table fxHide fxShow.gt-md class="crm-table">
                <thead>
                  <tr>
                    <th style="background: none; border: none;">
                      <picture>
                        <source class="webp" type="image/webp" 
                                srcset="//www.zohowebstatic.com/sites/zweb/images/crm/wrkfrce-cal-bgimg-2x.webp 2x,
                                        //www.zohowebstatic.com/sites/zweb/images/crm/wrkfrce-cal-bgimg.webp 1x">
                        <img src="//www.zohowebstatic.com/sites/zweb/images/crm/wrkfrce-cal-bgimg.png" 
                             class="main-image" 
                             alt="Price calculator" 
                             width="225" height="144">
                      </picture>
                    </th>
                    <th *ngFor="let provider of crmData.providers">
                      <div class="header-box">
                        <img [src]="provider.logo" alt="{{ provider.name }}" />
                        <h3>{{ provider.name }}</h3>
                        <p class="plan">{{ provider.plan }}</p>
                        <p class="price-new">₹{{ provider.pricePerUser }}/user/month</p>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let feature of crmData.features">
                    <td>{{ feature.label }}</td>
                    <td *ngFor="let provider of crmData.providers">
                      {{ provider[feature.key] }}
                    </td>
                  </tr>
                </tbody>
              </table>
              
                  <div  fxHide fxShow.lt-md  class="crm-table-container-mobile">
                    <table class="crm-table-two">
                      <thead>
                        <tr>
                         
                          <th><img src="" alt="zoho.png"> </th>
                          <th><img src="" alt="calsoft.png"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="section-heading">
                          <td colspan="2">Pricing</td>
                        </tr>
                        <tr>
                      
                          <td><div class="inner-padding-one">
                            Ultimate
                          </div> </td>
                          <td><div class="inner-padding">Salesforce Lightning Unlimited</div></td>
                        </tr>

                        <tr class="section-heading">
                          <td colspan="2">Total Price for 100 users</td>
                        </tr>
                        <tr>
                         
                          <td><div class="inner-padding-one">₹5200</div></td>
                          <td><div class="inner-padding">₹66500</div></td>
                        </tr>
                  
                        <tr class="section-heading">
                          <td colspan="2">Licensing Cost for 100 users</td>
                        </tr>
                        <tr>
                          
                          <td> <div class="inner-padding-one">₹5200</div></td>
                          <td><div class="inner-padding">₹33000</div></td>
                        </tr>
                  
                        <!-- Add more comparison sections -->
                      </tbody>
                    </table>
                  </div>
                  
                  
            </ng-container>
        </div>

        <!-- Normal image with animation -->
        <div [@fadeAnimation]="!showTable ? 'visible' : 'hidden'">
            <ng-template #normalImage>
                <picture>
                    <source class="webp" type="image/webp" 
                            srcset="//www.zohowebstatic.com/sites/zweb/images/crm/wrkfrce-cal-bgimg-2x.webp 2x,
                                    //www.zohowebstatic.com/sites/zweb/images/crm/wrkfrce-cal-bgimg.webp 1x">
                    <img src="//www.zohowebstatic.com/sites/zweb/images/crm/wrkfrce-cal-bgimg.png" 
                         class="main-image" 
                         alt="Price calculator" 
                         width="225" height="144">
                  </picture>
            </ng-template>
        </div>


    </div>
    <!-- <div class="crm-table-container">
        <table class="crm-table">
          <thead>
            <tr>
              <th style="background: none;border: none;"></th>
              <th *ngFor="let provider of crmData.providers">
                <div class="header-box">
                  <img [src]="provider.logo" alt="{{ provider.name }}" />
                  <h3>{{ provider.name }}</h3>
                  <p class="plan">{{ provider.plan }}</p>
                  <p class="price-new">₹{{ provider.pricePerUser }}/user/month</p>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="highlight-row">
              <td>Total Price for 100 users</td>
              <td *ngFor="let provider of crmData.providers">
                <b>₹{{ provider.totalPrice }}</b>
              </td>
            </tr>
            <tr>
              <td>Licensing Cost for 100 users</td>
              <td *ngFor="let provider of crmData.providers">
                ₹{{ provider.licensingCost }}
              </td>
            </tr>
            <tr>
              <td>AI (Scoring, Analytics included)</td>
              <td *ngFor="let provider of crmData.providers">
                {{ provider.ai }}
              </td>
            </tr>
            <tr>
              <td>BI</td>
              <td *ngFor="let provider of crmData.providers">
                {{ provider.bi }}
              </td>
            </tr>
            <tr>
              <td>Telephony</td>
              <td *ngFor="let provider of crmData.providers">
                {{ provider.telephony }}
              </td>
            </tr>
            <tr>
              <td>Sales Gamification</td>
              <td *ngFor="let provider of crmData.providers">
                {{ provider.gamification }}
              </td>
            </tr>
            <tr>
              <td>Document Management</td>
              <td *ngFor="let provider of crmData.providers">
                {{ provider.documentManagement }}
              </td>
            </tr>
          </tbody>
        </table>
      </div> -->
      

</div>